module.exports = __webpack_public_path__ + "img/svg - only laptop.74cdf68b.svg";